var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-white md__card--holder clearfix" },
    [
      _c(
        "modal",
        {
          attrs: { show: _vm.showEditCompanyModal },
          on: {
            "update:show": function ($event) {
              _vm.showEditCompanyModal = $event
            },
          },
        },
        [
          _c("template", { slot: "header" }, [
            _c(
              "h5",
              {
                staticClass: "modal-title",
                attrs: { id: "exampleModalLabel" },
              },
              [_vm._v("Edit Company")]
            ),
          ]),
          _c("AssignCompany", {
            attrs: { data: _vm.profile.company },
            on: {
              closeClicked: function ($event) {
                _vm.showEditCompanyModal = false
              },
              saveClicked: function ($event) {
                return _vm.alert("ddd")
              },
            },
          }),
        ],
        2
      ),
      _c("div", [
        _c(
          "div",
          {
            staticClass:
              "card-header d-flex align-items-center chat-header-title navbar-height bg-navy rounded-0",
          },
          [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "d-block ml-auto" },
              [
                _vm.profile.role && _vm.profile.role.name != "guest"
                  ? _c(
                      "base-button",
                      {
                        attrs: { type: "default", outline: "", size: "sm" },
                        on: { click: _vm.onLogoutClicked },
                      },
                      [
                        _c("span", { staticClass: "btn-inner--text" }, [
                          _vm._v("\n              Logout\n            "),
                        ]),
                        _c("span", { staticClass: "btn-inner--icon ml-1" }, [
                          _c("i", { staticClass: "far fa-sign-out" }),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm.profile.role && _vm.profile.role.name != "guest"
        ? _c(
            "form",
            {
              staticClass:
                "card shadow-none tf__edit--userinfo box-s border-0 rounded-0",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "card-header d-flex align-items-center justify-content-between mb-0 py-3 border-0",
                },
                [
                  _c(
                    "div",
                    {},
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "img_wrapper img-wrapper--avatar p-0 rounded-circle position-relative",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "img_box d-flex align-items-center justify-content-center h3 lh-1 mb-0 text-body bg-light w-100 h-100 rounded-circle overflow-hidden",
                            },
                            [
                              _vm.avatar
                                ? _c("img", {
                                    staticClass:
                                      "img-fluid shadow mh-100 mw-100",
                                    attrs: {
                                      alt: "Circle image",
                                      src: _vm.avatar,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-add bg-white",
                              attrs: { type: "button" },
                              on: { click: _vm.onShowCropperClick },
                            },
                            [_c("i", { staticClass: "fas fa-plus" })]
                          ),
                        ]
                      ),
                      _c("modal", { attrs: { show: _vm.showCropper } }, [
                        _vm.showCropper
                          ? _c(
                              "div",
                              { staticClass: "cropper" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "img_box" },
                                  [
                                    _c("vue-avatar", {
                                      ref: "vueavatar",
                                      attrs: {
                                        width: 400,
                                        height: 400,
                                        rotation: _vm.rotation,
                                        borderRadius: _vm.borderRadius,
                                        scale: _vm.scale,
                                        accept: "image/*",
                                        image: _vm.base64Avatar,
                                      },
                                      on: {
                                        "vue-avatar-editor:image-ready":
                                          _vm.onImageReady,
                                      },
                                    }),
                                    _c("br"),
                                    _c("label", { staticClass: "zoom" }, [
                                      _vm._v(
                                        "\n                  Zoom : " +
                                          _vm._s(_vm.scale) +
                                          "x\n                  "
                                      ),
                                      _c("br"),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.scale,
                                            expression: "scale",
                                          },
                                        ],
                                        attrs: {
                                          type: "range",
                                          min: "1",
                                          max: "5",
                                          step: "0.02",
                                        },
                                        domProps: { value: _vm.scale },
                                        on: {
                                          __r: function ($event) {
                                            _vm.scale = $event.target.value
                                          },
                                        },
                                      }),
                                    ]),
                                    _c("br"),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-sm btn-warning",
                                        attrs: { type: "button" },
                                        on: { click: _vm.onUploadProfilePic },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Upload profile picture\n                "
                                        ),
                                      ]
                                    ),
                                    _c("br"),
                                  ],
                                  1
                                ),
                                _c(
                                  "base-button",
                                  {
                                    staticClass: "ml-auto",
                                    attrs: { type: "link" },
                                    on: {
                                      click: function ($event) {
                                        _vm.showCropper = false
                                      },
                                    },
                                  },
                                  [_vm._v("Cancel")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                  _c("div", {}, [
                    !_vm.profileEditMode
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-outline-light",
                            on: {
                              click: function ($event) {
                                _vm.profileEditMode = !_vm.profileEditMode
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "btn-inner--text" }, [
                              _vm._v("Edit info"),
                            ]),
                            _vm._m(1),
                          ]
                        )
                      : _vm._e(),
                    _vm.profileEditMode
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-warning tf__save",
                            attrs: { type: "button" },
                            on: { click: _vm._onSaveProfileClicked },
                          },
                          [
                            _c("span", { staticClass: "btn-inner--text" }, [
                              _vm._v("Save"),
                            ]),
                            _vm._m(2),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm.profile.role.name != "guest"
                ? _c("div", { staticClass: "card-body bg-light-grey" }, [
                    _vm.profileEditMode
                      ? _c("div", { staticClass: "bg_disabled mb-0" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "small",
                              {
                                staticClass:
                                  "text-uppercase text-muted small-68 label-custom-sm font-weight-bold mb-2 d-block",
                              },
                              [_vm._v("First Name")]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.profile.first_name,
                                  expression: "profile.first_name",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                disabled: !_vm.profileEditMode,
                              },
                              domProps: { value: _vm.profile.first_name },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.profile,
                                    "first_name",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "small",
                              {
                                staticClass:
                                  "text-uppercase text-muted small-68 label-custom-sm font-weight-bold mb-2 d-block",
                              },
                              [_vm._v("Last Name")]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.profile.last_name,
                                  expression: "profile.last_name",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                disabled: !_vm.profileEditMode,
                              },
                              domProps: { value: _vm.profile.last_name },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.profile,
                                    "last_name",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "text-uppercase text-muted small-68 label-custom-sm font-weight-bold mb-2 d-block",
                                },
                                [_vm._v("Country")]
                              ),
                              _c(
                                "el-select",
                                {
                                  staticClass: "select-danger w-100",
                                  attrs: {
                                    readonly: true,
                                    placeholder: "",
                                    disabled: !_vm.profileEditMode,
                                  },
                                  model: {
                                    value: _vm.profile.country,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.profile, "country", $$v)
                                    },
                                    expression: "profile.country",
                                  },
                                },
                                _vm._l(_vm.countries, function (option) {
                                  return _c("el-option", {
                                    key: option,
                                    staticClass: "select-danger",
                                    attrs: { value: option, label: option },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "text-uppercase text-muted small-68 label-custom-sm font-weight-bold mb-2 d-block",
                                },
                                [_vm._v("Timezone")]
                              ),
                              _c(
                                "el-select",
                                {
                                  staticClass: "select-danger w-100",
                                  attrs: {
                                    readonly: true,
                                    placeholder: "",
                                    disabled: !_vm.profileEditMode,
                                  },
                                  model: {
                                    value: _vm.profile.timezone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.profile, "timezone", $$v)
                                    },
                                    expression: "profile.timezone",
                                  },
                                },
                                _vm._l(_vm.timezones, function (option) {
                                  return _c("el-option", {
                                    key: option,
                                    staticClass: "select-danger",
                                    attrs: { value: option, label: option },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "small",
                              {
                                staticClass:
                                  "text-uppercase text-muted small-68 label-custom-sm font-weight-bold mb-2 d-block",
                              },
                              [_vm._v("City")]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.profile.city,
                                  expression: "profile.city",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                disabled: !_vm.profileEditMode,
                              },
                              domProps: { value: _vm.profile.city },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.profile,
                                    "city",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "small",
                              {
                                staticClass:
                                  "text-uppercase text-muted small-68 label-custom-sm font-weight-bold mb-2 d-block",
                              },
                              [_vm._v("Email")]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.profile.email,
                                  expression: "profile.email",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                readonly: true,
                                disabled: !_vm.profileEditMode,
                              },
                              domProps: { value: _vm.profile.email },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.profile,
                                    "email",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "small",
                              {
                                staticClass:
                                  "text-uppercase text-muted small-68 label-custom-sm font-weight-bold mb-2 d-block",
                              },
                              [_vm._v("Password")]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.profile.password,
                                  expression: "profile.password",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "password",
                                disabled: !_vm.profileEditMode,
                              },
                              domProps: { value: _vm.profile.password },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.profile,
                                    "password",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ])
                      : _vm._e(),
                    !_vm.profileEditMode
                      ? _c("div", { staticClass: "bg_disabled mb-0" }, [
                          _c("ul", { staticClass: "list-unstyled mb-0" }, [
                            _vm.profile.first_name
                              ? _c("li", [
                                  _c(
                                    "small",
                                    {
                                      staticClass:
                                        "text-uppercase text-muted small-68 label-custom-sm font-weight-bold",
                                    },
                                    [_vm._v("First Name")]
                                  ),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.profile.first_name,
                                        expression: "profile.first_name",
                                      },
                                    ],
                                    staticClass:
                                      "w-100 form-control border-0 p-0 mb-4 bg-transparent h-1 font-weight-bold h-auto form-control-lg text-primary",
                                    attrs: {
                                      type: "text",
                                      disabled: !_vm.profileEditMode,
                                    },
                                    domProps: { value: _vm.profile.first_name },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.profile,
                                          "first_name",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ])
                              : _vm._e(),
                            _vm.profile.last_name
                              ? _c("li", [
                                  _c(
                                    "small",
                                    {
                                      staticClass:
                                        "text-uppercase text-muted small-68 label-custom-sm font-weight-bold",
                                    },
                                    [_vm._v("Last Name")]
                                  ),
                                  _c("input", {
                                    staticClass:
                                      "w-100 form-control border-0 p-0 mb-4 bg-transparent h-1 font-weight-bold h-auto form-control-lg text-primary",
                                    attrs: {
                                      type: "text",
                                      disabled: !_vm.profileEditMode,
                                    },
                                    domProps: { value: _vm.profile.last_name },
                                  }),
                                ])
                              : _vm._e(),
                            _vm.profile.country
                              ? _c(
                                  "li",
                                  [
                                    _c(
                                      "small",
                                      {
                                        staticClass:
                                          "text-uppercase text-muted small-68 label-custom-sm font-weight-bold",
                                      },
                                      [_vm._v("Country")]
                                    ),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass:
                                          "select-danger w-100 select--disabled",
                                        attrs: {
                                          readonly: true,
                                          placeholder: "",
                                          disabled: !_vm.profileEditMode,
                                        },
                                        model: {
                                          value: _vm.profile.country,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.profile,
                                              "country",
                                              $$v
                                            )
                                          },
                                          expression: "profile.country",
                                        },
                                      },
                                      _vm._l(_vm.countries, function (option) {
                                        return _c("el-option", {
                                          key: option,
                                          staticClass: "select-danger",
                                          attrs: {
                                            value: option,
                                            label: option,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.profile.timezone
                              ? _c(
                                  "li",
                                  [
                                    _c(
                                      "small",
                                      {
                                        staticClass:
                                          "text-uppercase text-muted small-68 label-custom-sm font-weight-bold",
                                      },
                                      [_vm._v("Timezone")]
                                    ),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass:
                                          "select-danger w-100 select--disabled",
                                        attrs: {
                                          readonly: true,
                                          placeholder: "",
                                          disabled: !_vm.profileEditMode,
                                        },
                                        model: {
                                          value: _vm.profile.timezone,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.profile,
                                              "timezone",
                                              $$v
                                            )
                                          },
                                          expression: "profile.timezone",
                                        },
                                      },
                                      _vm._l(_vm.timezones, function (option) {
                                        return _c("el-option", {
                                          key: option,
                                          staticClass: "select-danger",
                                          attrs: {
                                            value: option,
                                            label: option,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.profile.city
                              ? _c("li", [
                                  _c(
                                    "small",
                                    {
                                      staticClass:
                                        "text-uppercase text-muted small-68 label-custom-sm font-weight-bold",
                                    },
                                    [_vm._v("City")]
                                  ),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.profile.city,
                                        expression: "profile.city",
                                      },
                                    ],
                                    staticClass:
                                      "w-100 form-control border-0 p-0 mb-4 bg-transparent h-1 font-weight-bold h-auto form-control-lg text-primary",
                                    attrs: {
                                      type: "text",
                                      disabled: !_vm.profileEditMode,
                                    },
                                    domProps: { value: _vm.profile.city },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.profile,
                                          "city",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ])
                              : _vm._e(),
                            _vm.profile.email
                              ? _c("li", [
                                  _c(
                                    "small",
                                    {
                                      staticClass:
                                        "text-uppercase text-muted small-68 label-custom-sm font-weight-bold",
                                    },
                                    [_vm._v("Email")]
                                  ),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.profile.email,
                                        expression: "profile.email",
                                      },
                                    ],
                                    staticClass:
                                      "w-100 form-control border-0 p-0 mb-4 bg-transparent h-1 font-weight-bold h-auto form-control-lg text-primary",
                                    attrs: {
                                      type: "text",
                                      readonly: true,
                                      disabled: !_vm.profileEditMode,
                                    },
                                    domProps: { value: _vm.profile.email },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.profile,
                                          "email",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ])
                              : _vm._e(),
                          ]),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm.profile.role.name == "super_admin"
        ? _c("div", { staticClass: "card tf__banner--edit" }, [
            _c(
              "div",
              { staticClass: "card-header d-flex align-items-center" },
              [
                _vm._m(3),
                _c("div", { staticClass: "text-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-success",
                      on: { click: _vm.onAddBannerClicked },
                    },
                    [
                      _c("i", { staticClass: "fas fa-plus pr-1" }),
                      _vm._v("Add New\n          "),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "card-body" },
              _vm._l(_vm.banners, function (banner, ind) {
                return _c("article", { key: ind, staticClass: "mb-2" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: banner.banner_text,
                        expression: "banner.banner_text",
                      },
                    ],
                    domProps: { value: banner.banner_text },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(banner, "banner_text", $event.target.value)
                      },
                    },
                  }),
                  _c("div", { staticClass: "text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-danger",
                        on: {
                          click: function ($event) {
                            return _vm.onBannerDeleteClicked(banner)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fas fa-trash pr-1" }),
                        _vm._v("Delete\n            "),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-warning",
                        on: {
                          click: function ($event) {
                            return _vm.onSaveBannerClicked(banner)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fas fa-save pr-1" }),
                        _vm._v("Save\n            "),
                      ]
                    ),
                  ]),
                ])
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm.profile.role.name != "guest" && false
        ? _c("div", {}, [
            _vm.profile.role.name == "admin"
              ? _c("div", { staticClass: "card-header" }, [_vm._m(4)])
              : _vm._e(),
            _c("div", { staticClass: "card-header" }, [
              _c(
                "div",
                {
                  staticClass: "row align-items-center justify-content-between",
                },
                [
                  _vm._m(5),
                  _c("div", { staticClass: "col-md-6 text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-info",
                        on: {
                          click: function ($event) {
                            _vm.showEditCompanyModal = true
                          },
                        },
                      },
                      [_vm._m(6)]
                    ),
                  ]),
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c("div", { staticClass: "row align-items-center" }, [
                        _vm.profile.company
                          ? _c("div", { staticClass: "col ml-0" }, [
                              _c("h4", { staticClass: "card-title mb-0" }, [
                                _vm._v(_vm._s(_vm.profile.company.website)),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]),
            _vm.profile.role.name != "payer" && false
              ? _c("div", { staticClass: "card-body" }, [
                  _c("h4", { staticClass: "card-title mb-3" }, [
                    _vm._v("Account"),
                  ]),
                  _vm._m(7),
                  _c("div", { staticClass: "tab-content borderRadius-3" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-12 tab-pane fade active show",
                        attrs: { id: "payBills", role: "tabpanel" },
                      },
                      [
                        _vm._m(8),
                        _vm.profile.role.name == "admin" ||
                        _vm.profile.role.name == "super_admin"
                          ? _c(
                              "form",
                              { staticClass: "mt-1" },
                              [
                                _c("small", [_vm._v("Currency")]),
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "select-danger w-100",
                                    attrs: {
                                      placeholder: "Select Currency",
                                      "value-key": "id",
                                    },
                                    on: { change: _vm.onCurrecyChanged },
                                    model: {
                                      value: _vm.resource.currency,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.resource, "currency", $$v)
                                      },
                                      expression: "resource.currency",
                                    },
                                  },
                                  _vm._l(_vm.currencies, function (option) {
                                    return _c("el-option", {
                                      key: option.id,
                                      staticClass: "select-danger",
                                      attrs: {
                                        value: option,
                                        label:
                                          option.code +
                                          " (" +
                                          option.symbol +
                                          ")",
                                      },
                                    })
                                  }),
                                  1
                                ),
                                _c(
                                  "transition",
                                  { attrs: { name: "slide-fade" } },
                                  [
                                    _vm.profile.currency
                                      ? _c("div", { staticClass: "mt-3" }, [
                                          _c("div", { staticClass: "row" }, [
                                            _c("div", { staticClass: "col" }, [
                                              _c(
                                                "span",
                                                { staticClass: "h5" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.profile.currency.label
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c("small", [
                                                _vm._v(
                                                  "(" +
                                                    _vm._s(
                                                      _vm.profile.currency
                                                        .symbol
                                                    ) +
                                                    "-" +
                                                    _vm._s(
                                                      _vm.profile.currency.value
                                                    ) +
                                                    ")"
                                                ),
                                              ]),
                                            ]),
                                          ]),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._m(9),
                  ]),
                  false
                    ? _c("div", { staticClass: "d-flex mb-2" }, [
                        _vm._m(10),
                        _vm._m(11),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._m(12),
          ])
        : _vm._e(),
      _vm.profile.role.name != "guest" && false
        ? _c("div", { staticClass: "card" }, [
            _c(
              "div",
              { staticClass: "card-header d-flex align-items-center" },
              [
                _vm._m(13),
                _c("div", { staticClass: "text-right" }, [
                  _c("label", { staticClass: "col-auto custom-toggle px-0" }, [
                    _c("input", {
                      staticClass: "custom-control-input",
                      attrs: {
                        id: "demoProject",
                        type: "checkbox",
                        name: "dempProject",
                      },
                      domProps: { checked: _vm.profile.demoProject == "1" },
                      on: { click: _vm.onDemoProjectClicked },
                    }),
                    _c("span", {
                      staticClass: "custom-toggle-slider rounded-circle",
                      attrs: { "data-label-off": "OFF", "data-label-on": "ON" },
                    }),
                  ]),
                ]),
              ]
            ),
            _vm._m(14),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "card shadow-none border-0 rounded-0 bg-transparent" },
        [
          _vm._m(15),
          _c("div", { staticClass: "card-body pt-2" }, [
            _c("div", { staticClass: "modalfilter-row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "custom-control custom-radio custom-control-inline align-items-center justify-content-center",
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.profile.ganttViewMode,
                        expression: "profile.ganttViewMode",
                      },
                    ],
                    staticClass: "custom-control-input",
                    attrs: {
                      id: "projectsGanttDays",
                      type: "radio",
                      name: "ganttView",
                      value: "day",
                    },
                    domProps: {
                      checked: _vm._q(_vm.profile.ganttViewMode, "day"),
                    },
                    on: {
                      click: _vm.onGanttViewModeClicked,
                      change: function ($event) {
                        return _vm.$set(_vm.profile, "ganttViewMode", "day")
                      },
                    },
                  }),
                  _c(
                    "label",
                    {
                      staticClass:
                        "custom-control-label custom-control--label-custom lh-1 h-auto",
                      attrs: { for: "projectsGanttDays" },
                    },
                    [_vm._v("Days")]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "custom-control custom-radio custom-control-inline align-items-center justify-content-center",
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.profile.ganttViewMode,
                        expression: "profile.ganttViewMode",
                      },
                    ],
                    staticClass: "custom-control-input",
                    attrs: {
                      id: "projectsGanttMonth",
                      type: "radio",
                      value: "month",
                      name: "ganttView",
                    },
                    domProps: {
                      checked: _vm._q(_vm.profile.ganttViewMode, "month"),
                    },
                    on: {
                      click: _vm.onGanttViewModeClicked,
                      change: function ($event) {
                        return _vm.$set(_vm.profile, "ganttViewMode", "month")
                      },
                    },
                  }),
                  _c(
                    "label",
                    {
                      staticClass:
                        "custom-control-label custom-control--label-custom lh-1 h-auto",
                      attrs: { for: "projectsGanttMonth" },
                    },
                    [_vm._v("Month")]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "custom-control custom-radio custom-control-inline align-items-center justify-content-center",
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.profile.ganttViewMode,
                        expression: "profile.ganttViewMode",
                      },
                    ],
                    staticClass: "custom-control-input",
                    attrs: {
                      id: "projectsGanttYear",
                      type: "radio",
                      value: "year",
                      name: "ganttView",
                    },
                    domProps: {
                      checked: _vm._q(_vm.profile.ganttViewMode, "year"),
                    },
                    on: {
                      click: _vm.onGanttViewModeClicked,
                      change: function ($event) {
                        return _vm.$set(_vm.profile, "ganttViewMode", "year")
                      },
                    },
                  }),
                  _c(
                    "label",
                    {
                      staticClass:
                        "custom-control-label custom-control--label-custom lh-1 h-auto",
                      attrs: { for: "projectsGanttYear" },
                    },
                    [_vm._v("Year")]
                  ),
                ]
              ),
            ]),
            false
              ? _c("div", { staticClass: "modalfilter-row mt-3" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "custom-radio custom-control-inline mr-0 w-100",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.profile.ganttZoomMode,
                            expression: "profile.ganttZoomMode",
                          },
                        ],
                        staticClass: "custom-control-input",
                        attrs: {
                          id: "projectsZoom1",
                          type: "radio",
                          value: "few",
                          name: "projectsZoom",
                        },
                        domProps: {
                          checked: _vm._q(_vm.profile.ganttZoomMode, "few"),
                        },
                        on: {
                          click: _vm.onGanttZoomModeClicked,
                          change: function ($event) {
                            return _vm.$set(_vm.profile, "ganttZoomMode", "few")
                          },
                        },
                      }),
                      _c(
                        "label",
                        {
                          staticClass:
                            "custom-control-label custom-control--label-custom lh-1 h-auto",
                          attrs: { for: "projectsZoom1" },
                        },
                        [_vm._v("Few")]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "custom-radio custom-control-inline mr-0 w-100",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.profile.ganttZoomMode,
                            expression: "profile.ganttZoomMode",
                          },
                        ],
                        staticClass: "custom-control-input",
                        attrs: {
                          id: "projectsZoom2",
                          type: "radio",
                          value: "many",
                          name: "projectsZoom",
                        },
                        domProps: {
                          checked: _vm._q(_vm.profile.ganttZoomMode, "many"),
                        },
                        on: {
                          click: _vm.onGanttZoomModeClicked,
                          change: function ($event) {
                            return _vm.$set(
                              _vm.profile,
                              "ganttZoomMode",
                              "many"
                            )
                          },
                        },
                      }),
                      _c(
                        "label",
                        {
                          staticClass:
                            "custom-control-label custom-control--label-custom",
                          attrs: { for: "projectsZoom2" },
                        },
                        [_vm._v("Many")]
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm.profile.ganttViewMode == "day"
              ? _c("div", { staticClass: "modalfilter-row mt-3" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "custom-radio custom-control-inline mr-0 w-100 flex-wrap align-items-center",
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "form-control-label mr-auto text-uppercase form-control--small text-primary lh-1 mb-0",
                        },
                        [_vm._v("Display ")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "custom-control custom-radio custom-control-inline align-items-center justify-content-center mr-2",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.profile.ganttDayMode,
                                expression: "profile.ganttDayMode",
                              },
                            ],
                            staticClass: "custom-control-input",
                            attrs: {
                              id: "dayModeFullWeek",
                              type: "radio",
                              value: "full-week",
                              name: "ganttDay",
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.profile.ganttDayMode,
                                "full-week"
                              ),
                            },
                            on: {
                              click: _vm.onGanttDayModeClicked,
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.profile,
                                  "ganttDayMode",
                                  "full-week"
                                )
                              },
                            },
                          }),
                          _c(
                            "label",
                            {
                              staticClass:
                                "custom-control-label custom-control--label-custom lh-1 h-auto",
                              attrs: { for: "dayModeFullWeek" },
                            },
                            [_vm._v("Full week")]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "custom-control custom-radio custom-control-inline align-items-center justify-content-center mr-0",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.profile.ganttDayMode,
                                expression: "profile.ganttDayMode",
                              },
                            ],
                            staticClass: "custom-control-input",
                            attrs: {
                              id: "dayModeWorkDays",
                              type: "radio",
                              value: "work-days",
                              name: "ganttDay",
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.profile.ganttDayMode,
                                "work-days"
                              ),
                            },
                            on: {
                              click: _vm.onGanttDayModeClicked,
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.profile,
                                  "ganttDayMode",
                                  "work-days"
                                )
                              },
                            },
                          }),
                          _c(
                            "label",
                            {
                              staticClass:
                                "custom-control-label custom-control--label-custom lh-1 h-auto",
                              attrs: { for: "dayModeWorkDays" },
                            },
                            [_vm._v("Workdays")]
                          ),
                        ]
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            false
              ? _c("div", { staticClass: "modalfilter-row mt-2" }, [
                  _c(
                    "div",
                    { staticClass: "custom-radio custom-control-inline" },
                    [
                      _c("label", { staticClass: "form-control-label mr-4" }, [
                        _vm._v("Show"),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "custom-control custom-radio custom-control-inline",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.profile.ganttCommentMode,
                                expression: "profile.ganttCommentMode",
                              },
                            ],
                            staticClass: "custom-control-input",
                            attrs: {
                              id: "firstComment",
                              type: "radio",
                              value: "task-title",
                              name: "ganttComment",
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.profile.ganttCommentMode,
                                "task-title"
                              ),
                            },
                            on: {
                              click: _vm.onGanttCommentModeClicked,
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.profile,
                                  "ganttCommentMode",
                                  "task-title"
                                )
                              },
                            },
                          }),
                          _c(
                            "label",
                            {
                              staticClass:
                                "custom-control-label custom-control--label-custom",
                              attrs: { for: "firstComment" },
                            },
                            [_vm._v("Task title")]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "custom-control custom-radio custom-control-inline",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.profile.ganttCommentMode,
                                expression: "profile.ganttCommentMode",
                              },
                            ],
                            staticClass: "custom-control-input",
                            attrs: {
                              id: "lastComment",
                              type: "radio",
                              value: "last-comment",
                              name: "ganttComment",
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.profile.ganttCommentMode,
                                "last-comment"
                              ),
                            },
                            on: {
                              click: _vm.onGanttCommentModeClicked,
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.profile,
                                  "ganttCommentMode",
                                  "last-comment"
                                )
                              },
                            },
                          }),
                          _c(
                            "label",
                            {
                              staticClass:
                                "custom-control-label custom-control--label-custom",
                              attrs: { for: "lastComment" },
                            },
                            [_vm._v("Last comment")]
                          ),
                        ]
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            false
              ? _c("div", { staticClass: "modalfilter-row mt-2" }, [
                  _c(
                    "div",
                    { staticClass: "custom-radio custom-control-inline" },
                    [
                      _c("label", { staticClass: "form-control-label mr-4" }, [
                        _vm._v("Show Finance"),
                      ]),
                      _c("label", { staticClass: "custom-toggle" }, [
                        _c("input", {
                          staticClass: "custom-control-input",
                          attrs: {
                            id: "ShowFinance",
                            type: "checkbox",
                            value: "1",
                            name: "ShowFinance",
                          },
                          domProps: { checked: _vm.profile.showFinance == "1" },
                          on: { click: _vm.onShowFinanceClicked },
                        }),
                        _c("span", {
                          staticClass: "custom-toggle-slider rounded-circle",
                          attrs: {
                            id: "showRadio",
                            "data-label-off": "OFF",
                            "data-label-on": "ON",
                          },
                        }),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
            _c("div", { staticClass: "modalfilter-row mt-3" }, [
              _c(
                "div",
                {
                  staticClass: "custom-radio custom-control-inline mr-0 w-100",
                },
                [
                  _c(
                    "label",
                    {
                      staticClass:
                        "form-control-label mr-auto text-uppercase form-control--small text-primary mb-0",
                    },
                    [_vm._v("Use Days For Quote Calculation")]
                  ),
                  _c("label", { staticClass: "custom-toggle" }, [
                    _c("input", {
                      staticClass: "custom-control-input",
                      attrs: {
                        id: "quoteCalculationInterval",
                        type: "checkbox",
                        name: "ShowFinance",
                      },
                      domProps: {
                        checked: _vm.profile.quoteCalculationInterval == "DAY",
                      },
                      on: { click: _vm.onQuoteCalculationModeClicked },
                    }),
                    _c("span", {
                      staticClass: "custom-toggle-slider rounded-circle",
                      attrs: {
                        id: "showRadio",
                        "data-label-off": "OFF",
                        "data-label-on": "ON",
                      },
                    }),
                  ]),
                ]
              ),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass:
                "card-footer border-light-grey text-left rounded-0 bg-transparent",
            },
            [
              _c("div", { staticClass: "billing-section" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        _vm.$router
                          .push({ name: "billing.home" })
                          .catch((e) => {})
                      },
                    },
                  },
                  [
                    _c("button", { staticClass: "btn btn-secondary btn-sm" }, [
                      _vm._v(" Billing\n              Information"),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-block" }, [
      _c("div", { staticClass: "header-title" }, [
        _vm._v("Profile "),
        _c("span", { staticClass: "bracket" }, [_vm._v(" { ")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "btn-inner--icon ml-1" }, [
      _c("i", { staticClass: "far fa-edit" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "btn-inner--icon ml-1" }, [
      _c("i", { staticClass: "far fa-save" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col px-0" }, [
      _c("h4", { staticClass: "h3 mb-0" }, [_vm._v("Banners Text")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "row align-items-center justify-content-between" },
      [
        _c("div", { staticClass: "col-md-6" }, [
          _c("h4", { staticClass: "h3 mb-0" }, [_vm._v("Payment")]),
        ]),
        _c("div", { staticClass: "col-md-6 text-right" }, [
          _c("button", { staticClass: "btn btn-sm btn-info" }, [
            _c("span", { staticClass: "icon-sml" }, [
              _c("i", { staticClass: "fas fa-edit" }),
              _vm._v("\n                Connect Stripe\n              "),
            ]),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-6" }, [
      _c("h4", { staticClass: "h3 mb-0" }, [_vm._v("Company")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon-sml" }, [
      _c("i", { staticClass: "fas fa-edit" }),
      _vm._v("\n                Edit info\n              "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "ul",
      { staticClass: "nav tabPanel mb-3", attrs: { role: "tablist" } },
      [
        _c("li", [
          _c(
            "a",
            {
              staticClass: "custom-control custom-radio custom-control-inline",
              attrs: { href: "#payBills", role: "tab", "data-toggle": "tab" },
            },
            [
              _c("input", {
                staticClass: "custom-control-input",
                attrs: {
                  id: "finaceRadio",
                  name: "finaceRadio",
                  type: "checkbox",
                },
              }),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "finaceRadio" },
                },
                [_vm._v("$2 per project per month")]
              ),
            ]
          ),
        ]),
        _c("li", [
          _c(
            "a",
            {
              staticClass: "custom-control custom-radio custom-control-inline",
              attrs: { href: "#workBills", role: "tab", "data-toggle": "tab" },
            },
            [
              _c("input", {
                staticClass: "custom-control-input",
                attrs: {
                  id: "fileLimitRadio",
                  name: "fileLimitRadio",
                  type: "checkbox",
                },
              }),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "fileLimitRadio" },
                },
                [_vm._v("$10 per 1GB per month")]
              ),
            ]
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-group mb-4" }, [
      _c("div", { staticClass: "text-left" }, [
        _c("button", { staticClass: "btn btn-sm btn-success w-100" }, [
          _c("span", { staticClass: "icon-sml" }, [
            _c("i", { staticClass: "fas fa-plus" }),
            _vm._v(
              "\n                    Add/Edit credit card\n                  "
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "text-left mt-2" }, [
        _c("button", { staticClass: "btn btn-sm btn-warning w-100" }, [
          _c("span", { staticClass: "icon-sml" }, [
            _c("i", { staticClass: "fas fa-eye" }),
            _vm._v("\n                    View statements\n                  "),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "col-sm-12 tab-pane fade",
        attrs: { id: "workBills", role: "tabpanel" },
      },
      [
        _c("div", { staticClass: "custom-control custom-radio mb-3" }, [
          _c("input", {
            staticClass: "custom-control-input",
            attrs: {
              id: "workfinanceRadio",
              name: "workfinanceRadio",
              type: "checkbox",
            },
          }),
          _c(
            "label",
            {
              staticClass: "custom-control-label",
              attrs: { for: "workfinanceRadio" },
            },
            [_vm._v("Finance Active")]
          ),
        ]),
        _c("div", { staticClass: "custom-control custom-radio mb-3" }, [
          _c("input", {
            staticClass: "custom-control-input",
            attrs: {
              id: "workfileLimitRadio",
              name: "workfileLimitRadio",
              type: "checkbox",
            },
          }),
          _c(
            "label",
            {
              staticClass: "custom-control-label",
              attrs: { for: "workfileLimitRadio" },
            },
            [_vm._v("File Uploads")]
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col px-0" }, [
      _c("label", { staticClass: "form-control-label mr-4" }, [
        _vm._v("Show Billing"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "col-auto custom-toggle px-0" }, [
      _c("input", {
        staticClass: "custom-control-input",
        attrs: {
          id: "billing",
          type: "checkbox",
          "data-toggle": "collapse",
          "data-target": "#showBilling",
          "aria-expanded": "false",
          value: "billing",
          name: "billing",
        },
      }),
      _c("span", {
        staticClass: "custom-toggle-slider rounded-circle",
        attrs: { "data-label-off": "OFF", "data-label-on": "ON" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body d-none" }, [
      _c("div", { staticClass: "collapse", attrs: { id: "invtform1" } }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c("label", [_vm._v("Role")]),
            ]),
            _c("div", { staticClass: "col-md-12" }, [
              _c(
                "div",
                {
                  staticClass:
                    "custom-control custom-radio mb-3 custom-control-inline",
                },
                [
                  _c("input", {
                    staticClass: "custom-control-input",
                    attrs: {
                      id: "admin",
                      name: "custom-radio-2",
                      checked: "",
                      type: "radio",
                    },
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      attrs: { for: "admin" },
                    },
                    [_vm._v("Admin")]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "custom-control custom-radio mb-3 custom-control-inline",
                },
                [
                  _c("input", {
                    staticClass: "custom-control-input",
                    attrs: {
                      id: "finance",
                      name: "custom-radio-2",
                      type: "radio",
                    },
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      attrs: { for: "finance" },
                    },
                    [_vm._v("Finance")]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "custom-control custom-radio mb-3 custom-control-inline",
                },
                [
                  _c("input", {
                    staticClass: "custom-control-input",
                    attrs: {
                      id: "team",
                      name: "custom-radio-2",
                      type: "radio",
                    },
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      attrs: { for: "team" },
                    },
                    [_vm._v("Team Member")]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "custom-control custom-radio mb-3 custom-control-inline",
                },
                [
                  _c("input", {
                    staticClass: "custom-control-input",
                    attrs: {
                      id: "payer",
                      name: "custom-radio-2",
                      type: "radio",
                    },
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      attrs: { for: "payer" },
                    },
                    [_vm._v("Payer")]
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col px-0" }, [
      _c("h4", { staticClass: "h3 mb-0" }, [_vm._v("Demo Project")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "bg_disabled mb-0" }, [
        _c("small", [
          _vm._v(
            "You can assist Bracket with updates you want considered to our\n            project roadmap in the Demo project."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "card-header border-0 rounded-0 bg-transparent pt-3" },
      [
        _c("h6", { staticClass: "mb-0", attrs: { id: "PinchFilter" } }, [
          _vm._v("Gantt Chart"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }